import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import ThemeButton from "src/components/button/ThemeButton";
import ThemeSelect from "src/components/theme-select/ThemeSelect";
import { products } from "src/config/reviewSystemData";
import { Option } from "src/types/global/Option";
import Image from "next/image";

interface SelectProductToReviewProps {
  productToReview: Option;
  setProductToReview: Dispatch<SetStateAction<Option>>;
  setReviewStep: Dispatch<SetStateAction<number>>;
}

const SelectProductToReview = ({
  productToReview,
  setProductToReview,
  setReviewStep,
}: SelectProductToReviewProps) => {
  const t = useTranslations("ReviewForm");
  return (
    <>
      <section className="m-auto flex flex-col items-center justify-center gap-10">
        <div className="text-center">
          <h2 className="text-2xl font-bold">
            {t("what_do_you_think_about_our_product")}
          </h2>
          <p>{t("take_a_couple_of_minutes")}</p>
        </div>
        <div className="flex w-full flex-col">
          <p className="items-start justify-start text-sm text-start">
            {t("select_a_product")}
          </p>
          <ThemeSelect
            containerClasses="w-full"
            listOptionsClasses="text-start"
            options={products}
            value={productToReview}
            onChange={(product) => setProductToReview(product)}
            icon={
              <Image
                className="w-6"
                src={`/images/product-page/review-form/${productToReview.value}-icon.png`}
                alt="product image"
                width={0}
                height={0}
                sizes="2rem"
                priority
              />
            }
          />
        </div>
      </section>
      <div className="flex self-end">
        <ThemeButton
          className="mt-auto items-end"
          onClick={() => setReviewStep((prevstep) => prevstep + 1)}
          disabled={productToReview.value === "" || !productToReview}
        >
          {t("next")}
        </ThemeButton>
      </div>
    </>
  );
};

export default SelectProductToReview;
